import { Fragment, h } from "preact";
import { Link } from "react-router-dom";

import { classNames, renderIcon, uniqueID } from "../helpers";
import i18n from "../i18n";
import Tooltip from "./Tooltip.jsx";

export default function Tag({ children, tooltip, ...props }) {
  const classes = classNames(
    "tag",
    props.noHover ? "tag--no-hover" : "waves-effect waves-light",
    props.alert && "tag--alert",
    props.text && "tag--text",
    props.grey && "tag--grey",
    props.note && "tag--note",
    !props.text && !props.to && "tag--default",
    props.noIndent && "tag--noIndent",
    props.to && "tag--linked waves-dark",
    tooltip && "tag--hasTooltip",
    props.class
  );
  const tooltipItemId = tooltip && `tag-tooltip-${uniqueID()}`;

  let Tag = "span";
  if (props.to) {
    Tag = Link;
    props = { ...props, href: props.to };
  }

  return (
    <Fragment>
      <Tag {...props} class={classes} data-tooltip-id={tooltipItemId}>
        {renderIcon(props.iconFront, "tag__frontIcon icon--small")}
        <span class="tag__content">{children}</span>
        {renderIcon(props.iconBack, "tag__backIcon icon--small")}
      </Tag>
      {tooltipItemId && (
        <Tooltip className="nioomi-tooltip" id={tooltipItemId} place="bottom">
          {tooltip}
        </Tooltip>
      )}
    </Fragment>
  );
}
